import { Button } from "@mui/material";
import styled from "styled-components";

export const StyledButton = styled(Button)`
  && {
  height: 40px;
  margin-left: auto;
  @media(max-width:640px) {
    flex: 1;
  }
}
`

export const FiltersBox = styled.div`
  display: flex;
  gap: 16px;
  position: relative;
  flex-shrink: 0;

  @media (max-width: 960px) {
    flex: 0 0 auto;
  }
`

export const ModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  max-width: 600px;
  max-height: 90vh;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: min(1200px, 95vw);

  &:focus {
    outline: none !important;
  }
`;

export const ModalHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-shrink: 0;
  padding: 20px 24px 0 24px;
  gap: 12px;
  min-width: 0;
  box-sizing: border-box;

  & > button,
  & .MuiIconButton-root {
    flex-shrink: 0;
    min-width: 40px;
    min-height: 40px;
    padding: 8px;
  }
`

export const StyledControlButton = styled(Button)`
&& {
  width: 171px;
  height: 44px;
}`

export const ModalControlBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`

export const ModalContent = styled.div`
  display: flex;
  gap: 22px;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 20px 24px;
  box-sizing: border-box;
`
